<template>
<div>
<div class="xsmall-hide small-hide bg-1">
    </div>
    <div class="medium-hide large-hide xlarge-hide">
      <img src="../assets/naniungo-slide-12.jpg">
  </div>
 <div class="md-layout mt-20" style="margin-left:10vw; margin-right:10vw">
        <div class="md-layout-item">
          <h1>Unser Prozess für Bewerber</h1>
          <div class="sub">
            Einfach – schnell – persönlich
          </div>
           <div>
      <md-steppers md-vertical>
        <md-step id="first" md-label="Online-Bewerbung" md-description="Schritt 1">
          <p>Sie möchten Ihre Karriere vorantreiben und die nächste berufliche Herausforderung antreten? Wir bieten Ihnen ein großes Netzwerk an namhaften Unternehmen in den Bereichen Finance, IT, Marketing sowie den finance functions und unterstützen und begleiten Sie gerne auf Ihrem Weg die Karriereleiter hinauf. Mit ein paar Klicks starten Sie über den „Jetzt bewerben" Button Ihre berufliche Zukunft. Sobald wir Ihre Unterlagen erhalten haben, bestätigen wir deren Erhalt per Mail und freuen uns auf die nächsten Schritte mit Ihnen.</p>
        </md-step>
        <md-step id="second" md-label="Kennenlernen" md-description="Schritt 2">
          <p>Sobald wir Ihre Unterlagen gesichtet haben, vereinbaren wir im ersten Schritt ein Telefoninterview, um einen ersten Eindruck für Ihre Vorstellungen und Qualifikationen zu erhalten. Stimmen Ihre und unsere Vorstellungen überein, laden wir Sie im zweiten Schritt zu einem persönlichen Gespräch ein, um Ihre beruflichen Möglichkeiten und Opportunitäten zu analysieren. </p>
        </md-step>
        <md-step id="third" md-label="Vorstellung Ihrer beruflichen Möglichkeitenn"  md-description="Schritt 3">
          <p>Mit Ihnen gemeinsam besprechen wir, welche Optionen der Markt aktuell bereithält und wie wir Sie dabei unterstützen Ihren Traumjob zu finden. Offen – transparent – auf Augenhöhe. Wir freuen uns auf Ihre Unterlagen und darauf, SIE kennenzulernen!</p>
        </md-step>
      </md-steppers>
  </div>
        </div>
    </div>
      <div class="message dark secondary">
    <router-link style="width:100%;" v-bind:to="'blog'">
    <h1>zum Blog<md-icon class="green ml-20">arrow_forward</md-icon></h1>
    </router-link>
  </div>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Karriere',
  data() {
    return {
      firstName: "",
      lastName: "",
      jobTitle: "",
      emailAddressPrivate: "",
      phoneNumberBusiness: "",
      hobbies: "",
      ambition: "",
      level: "",
      function: "",
      carerix_id: "",
      functionOne:"",
      method:"",
      varCandidates: [{
          "ambition" : '',
          "isOpen"  : false,
          "addtoCart": false,
          "carerix_id": ''
      }]
    }
  },
  computed: {
    ...mapState({
      candidates: state =>
      state.candidates.candidates,
      cart: state =>
      state.cart.cart
    })
  },
  created() {
  // this.$store.dispatch('candidates/getCandidates');
  },
  methods: {
    ...mapActions ('candidates', 'cart', [
        'addCandidate',
        'deleteCandidate',
        'updateCandidate',
        'getCart'
    ]),
    toggleOpen(value) {
        var item = this.varCandidates.filter(obj => {
        return obj.ambition === value
        })[0]

        if (typeof item !== "undefined") {
        item.isOpen = !item.isOpen
        }
    },
    getToggleState(value) {
        const item = this.varCandidates.filter(obj => {
        return obj.ambition === value
        })[0]
        if (typeof item !== "undefined") {
          return item.isOpen
        }
    },
    toggleCart(value) {
      // const item = this.$store.state.cart.cart.filter(obj => {
      const item = this.varCandidates.filter(obj => {      
      return obj.ambition === value
      })[0]
      if (typeof item !== "undefined") {
        item.addtoCart = !item.addtoCart
      }
    },
    getCartState(value) {
      // const item = this.$store.state.cart.cart.filter(obj => {
      const item = this.varCandidates.filter(obj => {
      return obj.ambition === value
      })[0]
      if (typeof item !== "undefined") {
        return item.addtoCart
      }
    }
  },
  mounted() {
    // if (localStorage.getItem('toggle') === 'true' && localStorage.getItem('toggle').length ===  this.$store.state.candidates.candidates.length) {
    if (localStorage.getItem('varCandidates')) {
          this.varCandidates = JSON.parse(localStorage.getItem('varCandidates'));
    } else {
      for(var i in this.$store.state.candidates.candidates) {
        var item = this.$store.state.candidates.candidates[i];
        this.varCandidates.push({
          "ambition" : item.ambition,
          "isOpen"  : false,
          "addtoCart": false,
          "carerix_id": item.carerix_id
      });
    }
    }
  },
  watch: {
    varCandidates: {
      handler() {
      localStorage.setItem('varCandidates', JSON.stringify(this.varCandidates));
      this.$store.dispatch('cart/getCart');
      // this.getCart();
      },
    deep: true
  }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../assets/css/shared.scss';
.bg-1{
  background: url("../assets/naniungo-slide-12.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height:500px;
}
.profiles{
  margin-left:10px;
  margin-right:10px;

.md-card-header {
    padding: 16px;
}

.md-card {
    margin: 10px;
    width:55vw;
    display: inline-block;
    vertical-align: top;
}

// .md-layout{
//   margin-left:10vw !important; 
//   margin-right:10vw !important;
// }

@media (min-width: 300px) and (max-width: 1300px) {
  .md-card {
    width:50vw;
    }
}

.md-title{
  // margin-right:80px !important;
  h3{
    font-size:30px !important;
    margin-top:-2px;
    font-weight: 900;
  }
}
.md-subhead{
  // margin-right:80px !important;
  p{
    font-size:16px !important;
    color: $primary-font;
  }
}
.md-card-actions{
  margin-bottom:5px;
  margin-right:5px;
}
}


</style>
